import { render, staticRenderFns } from "./UnmatchedResultsPage.vue?vue&type=template&id=fdc791d6&scoped=true&"
import script from "./UnmatchedResultsPage.vue?vue&type=script&lang=js&"
export * from "./UnmatchedResultsPage.vue?vue&type=script&lang=js&"
import style0 from "./UnmatchedResultsPage.vue?vue&type=style&index=0&id=fdc791d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc791d6",
  null
  
)

export default component.exports